import styled from 'styled-components';
import { device } from 'src/styles/global';
import {
  LoadingWrapper as BaseLoadingWrapper,
  LoadingSkeleton as BaseLoadingSkeleton,
  SkeletonBlock,
} from '../Dashboard.styles';

export const LoadingWrapper = styled(BaseLoadingWrapper)`
  box-sizing: border-box;
  overflow-x: hidden;

  @media ${device.mobile} {
    padding-top: 90px;
  }
`;

export const LoadingSkeleton = styled(BaseLoadingSkeleton)`
  box-sizing: border-box;
  gap: 0;
`;

export const HeaderSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 24px;

  @media ${device.mobile} {
    gap: 16px;
    padding-bottom: 16px;
  }
`;

export const HeaderControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  @media ${device.mobile} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const SummarySkeletonRow = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  padding-bottom: 12px;

  @media ${device.mobile}, ${device.tablet}, ${device.ipad} {
    flex-direction: column;
    gap: 16px;
    padding-bottom: 16px;
  }
`;

export const TrackingSummarySkeleton = styled(SkeletonBlock)<{
  $isTrackingReport: boolean;
}>`
  flex: 0 1 ${({ $isTrackingReport }) => ($isTrackingReport ? '30%' : '400px')};
  width: auto;
  min-width: 0;
  height: 294px;

  @media ${device.mobile}, ${device.tablet}, ${device.ipad} {
    flex: none;
    width: 100%;
    height: 180px;
  }
`;

export const OverviewSummarySkeleton = styled(SkeletonBlock)<{
  $isTrackingReport: boolean;
}>`
  flex: 1 1 ${({ $isTrackingReport }) => ($isTrackingReport ? '70%' : '910px')};
  width: auto;
  min-width: 0;
  height: 294px;

  @media ${device.mobile}, ${device.tablet}, ${device.ipad} {
    flex: none;
    width: 100%;
    height: 180px;
  }
`;

export const InsightsSkeletonRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 24px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 12px 0px 24px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  @media ${device.mobile}, ${device.tablet}, ${device.ipad} {
    gap: 16px;
    padding: 0px 0px 16px;
  }
`;

export const InsightSkeletonCard = styled(SkeletonBlock)`
  flex: 0 0 344px;
  width: auto;
  min-width: 344px;
  max-width: 344px;
  height: 180px;

  @media ${device.mobile}, ${device.tablet}, ${device.ipad} {
    flex: none;
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`;

export const ContentRow = styled.div<{ $gap?: string }>`
  display: flex;
  gap: ${({ $gap }) => $gap || '24px'};
  width: 100%;

  @media ${device.mobile} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const SectionGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;

  @media ${device.mobile} {
    padding-bottom: 16px;
  }
`;

export { SkeletonBlock };
